// ---------------------------------------------------------------------
// App-level session (NOT a Shopify login). This store uses Shopify's new
// Customer Accounts, which don't let any third party — including this
// script — mint a real Shopify session; only Shopify's own hosted login
// can do that. So instead, once the phone is OTP-verified (via the
// otp-backend's /api/otp/send + /api/otp/verify) and the backend has
// found/created the matching Shopify customer, we store our own signed
// token client-side and use it purely to drive "logged in" UI (greeting,
// login button state). See otp-backend/README.md.
// ---------------------------------------------------------------------
var SESSION_KEY = 'vro_session';

function loadSession() {
  try {
    var raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    var parsed = JSON.parse(raw);
    if (!parsed || !parsed.token || !parsed.customer) return null;

    // Decode the JWT payload (no signature check — this is a cosmetic,
    // client-side expiry check only; the backend re-verifies the
    // signature on every real use of the token).
    var payloadPart = parsed.token.split('.')[1];
    if (payloadPart) {
      var payload = JSON.parse(atob(payloadPart.replace(/-/g, '+').replace(/_/g, '/')));
      if (payload.exp && Date.now() >= payload.exp * 1000) return null;
    }
    return parsed;
  } catch (e) {
    return null;
  }
}

/* loginPhone is the number the shopper actually typed and verified, kept
   alongside the customer record the backend matched to it. The two are
   not always the same: the record carries whatever phone Shopify has on
   that customer, which can be an older number, and that is what the
   profile was showing. The number someone signed in with is, by
   definition, their login number, so it is stored and preferred. */
function saveSession(token, customer, loginPhone) {
  try {
    localStorage.setItem(SESSION_KEY, JSON.stringify({
      token: token, customer: customer, loginPhone: loginPhone || null
    }));
  } catch (e) { /* storage unavailable, ignore */ }
}

function clearSession() {
  try { localStorage.removeItem(SESSION_KEY); } catch (e) { /* ignore */ }
}

// Header chrome that Liquid cannot decide (the OTP session lives only in
// localStorage): the login button carries data-session-guest, the account
// pill data-session-signed-in. Only one shows at a time.
function toggleSessionChrome(signedIn) {
  document.querySelectorAll('[data-session-guest]').forEach(function (el) { el.hidden = signedIn; });
  document.querySelectorAll('[data-session-signed-in]').forEach(function (el) { el.hidden = !signedIn; });
}

function applySessionUI(customer) {
  toggleSessionChrome(true);
  var label = (customer && customer.firstName) ? customer.firstName : 'My account';
  document.querySelectorAll('.account-chip__name').forEach(function (el) {
    if (!el.dataset.originalLabel) el.dataset.originalLabel = el.textContent;
    el.textContent = label;
  });
  var fl = label.trim().charAt(0).toUpperCase();
  document.querySelectorAll('.account-chip__avatar').forEach(function (el) {
    if (!el.dataset.originalLabel) el.dataset.originalLabel = el.textContent;
    el.textContent = fl;
  });
}

function applyGuestUI() {
  toggleSessionChrome(false);
  document.querySelectorAll('.account-chip__name').forEach(function (el) {
    if (el.dataset.originalLabel) el.textContent = el.dataset.originalLabel;
  });
}

// Exposed so other inline/page scripts (e.g. the profile page's own
// guard) can read/react to the same session without re-implementing it.
window.VroSession = {
  load: loadSession,
  save: saveSession,
  clear: clearSession,
  applyLoggedInUI: applySessionUI,
  applyGuestUI: applyGuestUI
};

document.addEventListener('DOMContentLoaded', function () {
  var session = loadSession();
  if (session) {
    applySessionUI(session.customer);
  } else {
    clearSession();
  }

  var sheet = document.getElementById('loginSheet');
  var backdrop = document.getElementById('loginSheetBackdrop');
  if (!sheet || !backdrop) return;

  var apiBase = (sheet.getAttribute('data-otp-api-base') || '').replace(/\/$/, '');

  var errorBox = document.getElementById('loginSheetError');
  var phoneStep = sheet.querySelector('[data-login-step="phone"]');
  var otpStep = sheet.querySelector('[data-login-step="otp"]');

  var phoneForm = document.getElementById('loginSheetPhoneForm');
  var phoneInput = document.getElementById('loginSheetPhone');
  var sendBtn = document.getElementById('loginSheetSendBtn');

  var otpForm = document.getElementById('loginSheetOtpForm');
  var otpInput = document.getElementById('loginSheetOtp');
  var verifyBtn = document.getElementById('loginSheetVerifyBtn');
  var otpPhoneDisplay = document.getElementById('loginSheetOtpPhoneDisplay');

  var resendBtn = document.getElementById('loginSheetResendBtn');
  var resendCooldownEl = document.getElementById('loginSheetResendCooldown');

  var lastFocused = null;
  var isOpen = false;
  var currentPhone = '';
  var resendTimer = null;
  var otpToken = null;

  function showError(message) {
    if (!errorBox) return;
    errorBox.textContent = message;
    errorBox.hidden = false;
  }

  function clearError() {
    if (!errorBox) return;
    errorBox.hidden = true;
    errorBox.textContent = '';
  }

  function setStep(step) {
    clearError();
    [phoneStep, otpStep].forEach(function (el) {
      if (el) el.classList.remove('is-active');
    });
    var target = step === 'otp' ? otpStep : phoneStep;
    if (target) target.classList.add('is-active');
    var field = step === 'otp' ? otpInput : phoneInput;
    if (field) field.focus({ preventScroll: true });
  }

  async function postJson(path, payload) {
    if (!apiBase) {
      throw new Error('OTP backend isn\'t configured yet (Theme settings → OTP login).');
    }
    var res;
    try {
      res = await fetch(apiBase + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
    } catch (networkErr) {
      throw new Error('Network error — check your connection and try again.');
    }
    var data = {};
    try { data = await res.json(); } catch (e) { /* ignore */ }
    if (!res.ok || !data.ok) {
      throw new Error((data && data.error) || 'Something went wrong, try again.');
    }
    return data;
  }

  function setBusy(btn, busyText, isBusy) {
    if (!btn) return;
    if (isBusy) {
      btn.dataset.originalText = btn.textContent;
      btn.textContent = busyText;
      btn.disabled = true;
    } else {
      btn.textContent = btn.dataset.originalText || btn.textContent;
      btn.disabled = false;
    }
  }

  function startResendCooldown(seconds) {
    if (!resendBtn) return;
    clearInterval(resendTimer);
    var remaining = seconds;
    resendBtn.hidden = true;
    resendCooldownEl.hidden = false;
    resendCooldownEl.textContent = 'Resend in ' + remaining + 's';
    resendTimer = setInterval(function () {
      remaining -= 1;
      if (remaining <= 0) {
        clearInterval(resendTimer);
        resendCooldownEl.hidden = true;
        resendBtn.hidden = false;
        return;
      }
      resendCooldownEl.textContent = 'Resend in ' + remaining + 's';
    }, 1000);
  }

  async function sendOtp() {
    var data = await postJson('/api/otp/send', { phone: currentPhone });
    otpToken = data.otpToken;
  }

  if (phoneForm) {
    phoneForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      clearError();

      var digits = (phoneInput.value || '').replace(/\D/g, '');
      if (digits.length !== 10) {
        showError('Enter a valid 10-digit mobile number.');
        return;
      }

      setBusy(sendBtn, 'Sending…', true);
      try {
        currentPhone = digits;
        await sendOtp();
        otpPhoneDisplay.textContent = digits;
        otpInput.value = '';
        setStep('otp');
        startResendCooldown(30);
      } catch (err) {
        showError(err.message);
      } finally {
        setBusy(sendBtn, '', false);
      }
    });
  }

  if (otpForm) {
    otpForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      clearError();

      var code = (otpInput.value || '').trim();
      if (!/^\d{6}$/.test(code)) {
        showError('Enter the code we sent you.');
        return;
      }
      if (!otpToken) {
        showError('Request a new code and try again.');
        return;
      }

      setBusy(verifyBtn, 'Verifying…', true);
      try {
        var emailInput = document.getElementById('loginSheetEmail');
        var optionalEmail = emailInput ? emailInput.value : undefined;
        var data = await postJson('/api/otp/verify', { otpToken: otpToken, code: code, email: optionalEmail });

        saveSession(data.sessionToken, data.customer, currentPhone ? '+91' + currentPhone : null);
        applySessionUI(data.customer);
        // The profile panel's content (profile-header.liquid,
        // profile-orders.liquid, etc.) is rendered once at page load and
        // only reveals/populates itself on DOMContentLoaded — which has
        // already fired by the time login finishes here. Without this
        // event, the panel stays visually blank until the next full page
        // load (i.e. until the user navigates somewhere else), even
        // though a valid session now exists.
        document.dispatchEvent(new CustomEvent('vro:session-changed'));
        closeSheet();
      } catch (err) {
        showError(err.message);
        setBusy(verifyBtn, '', false);
      }
    });
  }

  if (resendBtn) {
    resendBtn.addEventListener('click', async function () {
      clearError();
      resendBtn.disabled = true;
      try {
        await sendOtp();
        startResendCooldown(30);
      } catch (err) {
        showError(err.message);
      } finally {
        resendBtn.disabled = false;
      }
    });
  }

  sheet.querySelectorAll('[data-login-back-to-phone]').forEach(function (btn) {
    btn.addEventListener('click', function () { setStep('phone'); });
  });

  if (phoneInput) {
    phoneInput.addEventListener('input', function () {
      phoneInput.value = phoneInput.value.replace(/\D/g, '').slice(0, 10);
    });
  }
  if (otpInput) {
    otpInput.addEventListener('input', function () {
      otpInput.value = otpInput.value.replace(/\D/g, '').slice(0, 6);
    });
  }

  function openSheet() {
    if (isOpen) return;
    isOpen = true;
    lastFocused = document.activeElement;
    setStep('phone');

    backdrop.hidden = false;
    sheet.removeAttribute('inert');
    document.body.classList.add('login-sheet-open');

    // Force a reflow so the transition runs from the starting transform/opacity.
    void sheet.offsetHeight;

    requestAnimationFrame(function () {
      backdrop.classList.add('is-visible');
      sheet.classList.add('is-open');
      sheet.setAttribute('aria-hidden', 'false');
    });

    if (phoneInput) phoneInput.focus({ preventScroll: true });
  }

  function closeSheet() {
    if (!isOpen) return;
    isOpen = false;

    backdrop.classList.remove('is-visible');
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('login-sheet-open');

    var onEnd = function (e) {
      if (e.target !== sheet) return;
      sheet.setAttribute('inert', '');
      backdrop.hidden = true;
      sheet.removeEventListener('transitionend', onEnd);
    };
    sheet.addEventListener('transitionend', onEnd);

    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', function (e) {
    var openTrigger = e.target.closest('[data-login-open]');
    if (openTrigger) {
      e.preventDefault();

      var current = loadSession();
      if (current) {
        // Already logged in — open the profile popup in place (see
        // snippets/profile-panel.liquid) instead of navigating away.
        // Same popup on mobile and desktop; only its CSS presentation
        // (full-screen sheet vs. right-side panel) differs by breakpoint.
        if (window.VroProfilePanel) window.VroProfilePanel.open();
        return;
      }

      openSheet();
      return;
    }
    var closeTrigger = e.target.closest('[data-login-close]');
    if (closeTrigger) {
      closeSheet();
      return;
    }
    if (e.target === backdrop) {
      closeSheet();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) closeSheet();
  });
});
